import { render, staticRenderFns } from "./ExtratoFornecedorList.vue?vue&type=template&id=1d10f303"
import script from "./ExtratoFornecedorList.vue?vue&type=script&lang=js"
export * from "./ExtratoFornecedorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports